import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  MANAGE_SUBS_SAVE_ORG_DROPDOWN_LIST,
} from './constants';

export function saveOrgDropdownList(data) {
  return {
    type: MANAGE_SUBS_SAVE_ORG_DROPDOWN_LIST,
    data,
  };
}

export function useSaveOrgDropdownList() {
  const dispatch = useDispatch();
  const boundAction = useCallback((...params) => dispatch(saveOrgDropdownList(...params)), [dispatch]);
  return { saveOrgDropdownList: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_SAVE_ORG_DROPDOWN_LIST:
      return {
        ...state,
        orgDropdownList: action.data,
      };

    default:
      return state;
  }
}
